import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import SectionLabel from "../site/SectionLabel";
import { HOME_SECTIONS } from "@/constants/testIds";
import { TESTIMONIALS } from "@/lib/data";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];
  const next = () => setI((v) => (v + 1) % TESTIMONIALS.length);
  const prev = () => setI((v) => (v - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);

  return (
    <section
      data-testid={HOME_SECTIONS.testimonials}
      className="relative bg-ink-900 py-28 lg:py-40"
    >
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <SectionLabel number="11">Client Voices</SectionLabel>
        <div className="mt-10 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-2">
            <Quote size={64} strokeWidth={1} className="text-gold" />
          </div>
          <div className="lg:col-span-10">
            <AnimatePresence mode="wait">
              <motion.blockquote
                key={i}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -16 }}
                transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
              >
                <p className="font-display text-3xl leading-[1.15] tracking-tight text-ivory lg:text-5xl">
                  &ldquo;{t.quote}&rdquo;
                </p>
                <footer className="mt-10 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
                  <div>
                    <div className="font-display text-xl italic text-gold">{t.author}</div>
                    <div className="mt-1 font-sans text-xs uppercase tracking-widest text-ivory-muted">
                      {t.role} · {t.company}
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <button
                      aria-label="Previous testimonial"
                      onClick={prev}
                      className="flex h-11 w-11 items-center justify-center rounded-full border border-ivory/10 text-ivory hover:border-gold hover:text-gold transition-colors"
                    >
                      <ChevronLeft size={16} />
                    </button>
                    <div className="font-sans text-[11px] uppercase tracking-widest text-ivory-dim">
                      {String(i + 1).padStart(2, "0")} / {String(TESTIMONIALS.length).padStart(2, "0")}
                    </div>
                    <button
                      aria-label="Next testimonial"
                      onClick={next}
                      className="flex h-11 w-11 items-center justify-center rounded-full border border-ivory/10 text-ivory hover:border-gold hover:text-gold transition-colors"
                    >
                      <ChevronRight size={16} />
                    </button>
                  </div>
                </footer>
              </motion.blockquote>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
}
